import axios from "axios";

const API_BASE_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL || "https://ebilling.askonly.in/api"
    : process.env.REACT_APP_LOCAL_API_URL || "http://127.0.0.1:8000/api";
export const API = API_BASE_URL;

let isRedirectingAfterUnauthorized = false;

export const clearAuthSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  sessionStorage.removeItem("permissions");
};

const isLoginRequest = (config) => {
  const url = String(config.url || "").split("?")[0];
  return url === "/login" || url.endsWith("/login");
};

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    Accept: "application/json",
  },
});

const addAuthInterceptors = (client) => {
  client.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error.response?.status === 401 &&
        !isLoginRequest(error.config || {}) &&
        !isRedirectingAfterUnauthorized
      ) {
        clearAuthSession();
        isRedirectingAfterUnauthorized = true;

        if (window.location.pathname !== "/login") {
          window.location.replace("/login");
        }
      }

      return Promise.reject(error);
    }
  );
};

addAuthInterceptors(api);

export const apiBlob = axios.create({
  baseURL: API_BASE_URL,
  responseType: "blob",
  timeout: 60000,
  headers: {
    Accept:
      "application/json, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
});

addAuthInterceptors(apiBlob);

export default api;
